import { Controller } from "@hotwired/stimulus"

// Caselle che React teneva in un array nell'ordine dei clic (toggle: una casella scelta va in fondo, tolta esce), dove
// l'ordine conta per il server (metodi e requisiti delle regole di rendicontazione, interventi delle condizioni
// tecniche). La casella non ha nome (data-ordinato="chiave"); i valori scelti sono i campi nascosti dello span
// data-elenco-ordinato="chiave" della stessa riga (VerificaHelper#elenco_ordinato), nell'ordine salvato e poi dei clic.
//   <div data-controller="elenco-ordinato" data-action="change->elenco-ordinato#scegli"> … righe … </div>
export default class extends Controller {
  scegli(event) {
    const casella = event.target
    const chiave = casella.dataset?.ordinato
    if (!chiave) return
    const elenco = this.elenco(casella, chiave)
    if (!elenco) return
    const campo = [...elenco.querySelectorAll("[data-valore]")].find((x) => x.dataset.valore === casella.value)
    if (!casella.checked) { campo?.remove(); return }
    if (campo) return
    const nuovo = elenco.querySelector("input").cloneNode()
    nuovo.value = casella.value
    nuovo.dataset.valore = casella.value
    elenco.append(nuovo)
  }

  elenco(casella, chiave) {
    const ambito = casella.closest("[data-righe-target~='riga']") || this.element
    return ambito.querySelector(`[data-elenco-ordinato="${chiave}"]`)
  }
}
